export class loadListModel {
    "applianceId" : number;
    "applianceName"	:	string = "";
    "applianceWatt"	: number;
    "applianceCount" : number;
  }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/loadList/loadListModel.ts